<p-dialog
  (onHide)="closeModal()"
  [(visible)]="displayModal"
  [closable]="true"
  [header]="getTitle()"
  [modal]="true"
  styleClass="w-10/12 xl:w-3/5"
>
  @if (form) {
  <lib-dynamic-form [form]="form" [fields]="fields"></lib-dynamic-form>
  }

  <ng-template pTemplate="footer">
    <p-button (click)="closeModal()" severity="danger" variant="outlined">Cancelar</p-button>
    <p-button (click)="onSubmit()" [disabled]="form.invalid" severity="primary">
      {{ getButtonLabel() }}
    </p-button>
  </ng-template>
</p-dialog>
